/**
 * Reparto visual de las líneas bypass ("bajo pedido") del carrito.
 *
 * Una línea bypass con más unidades que stock sigue siendo UNA línea en el
 * backend, pero en el carrito se enseña partida: las unidades cubiertas por
 * stock con el resto del pedido y el exceso en la zona "Bajo pedido", que
 * además no cuenta para el pedido mínimo del envío gratuito.
 */
export const onDemandUnits = (product) =>
    product?.stockBypass === true
        ? Math.max(product.quantity - Math.max(product.stock ?? 0, 0), 0)
        : 0;

export const servedUnits = (product) => product.quantity - onDemandUnits(product);

export const onDemandAmount = (products = []) =>
    products.reduce((sum, product) => sum + onDemandUnits(product) * product.sellingPrice, 0);

// Importe bajo pedido CON IVA. product.tax es porcentaje entero (21, 10...),
// igual que item.impuesto en CartConverter del api.
export const onDemandTaxedAmount = (products = []) =>
    products.reduce((sum, product) =>
        sum + onDemandUnits(product) * product.sellingPrice * (1 + (product.tax ?? 0) / 100), 0);
